export class NumberUtil {
	static roundToTwoDecimals(value: number): number {
		return Math.round(value * 100) / 100;
	}

	static roundToNDecimals(value: number, n: number): number {
		const factor = Math.pow(10, n);
		return Math.round(value * factor) / factor;
	}

	static compareDifferentNumbers(a: number, b: number): boolean {
		if ((a < b) || (isNaN(a) && !isNaN(b)) || (!isNaN(a) && isNaN(b)) || (a > b)) {
			return true; // Different numbers
		} else {
			return false; // Same numbers
		}
	}
}